const LEGAL_BASIS_OPTIONS = [
  {
    value: "NOTICE_1",
    description: "Section 1 of the Statistics of Trade Act 1947.",
  },
  {
    value: "NOTICE_2",
    description: "Sections 2 and 3 of the Statistics of Trade Act 1947.",
  },
  {
    value: "NOTICE_3",
    description: "Sections 3 and 4 of the Statistics of Trade Act 1947.",
  },
  {
    value: "NOTICE_NI",
    description:
      "Article 5 of the Statistics of Trade and Employment (Northern Ireland) Order 1988.",
  },
  {
    value: "NOTICE_FUELS",
    description:
      "Petroleum Act 1998 and Section 1 of the Statistics of Trade Act 1947.",
  },
  {
    value: "VOLUNTARY",
    description: "Voluntary",
  },
];

export default LEGAL_BASIS_OPTIONS;
